import { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { GrClose } from 'react-icons/gr'
import { ReportView } from '@app/components/ada'
import { useRestWebsiteContext } from '../providers/rest/rest-website'
import { HeadlessFullScreenModal } from './headless-full'
import { Button, SnackBar } from '../general'
import { AppManager } from '@app/managers'

interface BottomDrawer {
  website?: any
  bottomModal?: boolean
  closeFeed: () => void
  disablePlayground?: boolean
  disableTabs?: boolean
  authenticated?: boolean
}

export function BottomDrawer({
  bottomModal,
  closeFeed,
  website,
  disablePlayground,
  disableTabs,
  authenticated,
}: BottomDrawer) {
  const { t, lang } = useTranslation('common')

  const pdfReport = 'validationSummary' in website

  return (
    <HeadlessFullScreenModal open={!!bottomModal} onClose={closeFeed}>
      <ReportView
        t={t}
        lang={lang}
        closeButton={
          <Button
            className={
              'text-lg hover:text-gray-800 hover:bg-gray-200 rounded-3xl px-3 py-3'
            }
            onClick={closeFeed}
            border={false}
            iconButton
          >
            <>
              <span className='sr-only'>{t('dismiss')}</span>
              <GrClose className='grIcon' />
            </>
          </Button>
        }
        authenticated={authenticated}
        website={website}
        pdfReport={pdfReport}
        disableTabs={disableTabs}
        disablePlayground={disablePlayground}
        download={false}
      />
      <SnackBar snackID={'message-report'} />
    </HeadlessFullScreenModal>
  )
}

// rest component to get website data
export function MarketingBottomTemporaryDrawer({
  authenticated,
}: {
  authenticated?: boolean
}) {
  const { data, loading, closeModal, search, selectedFile, setSearch } =
    useRestWebsiteContext()

  /* properties to determine modal data and visibility */
  const { websiteData, visible } = useMemo(() => {
    const validDomain = selectedFile ? data : data && (data.url || data.domain)
    const containsData = selectedFile
      ? data
      : data && (validDomain || !!data.issues)

    return {
      websiteData: data
        ? { ...data, url: validDomain ? search : undefined }
        : { url: search },
      visible: (loading && !containsData) || !!containsData,
    }
  }, [data, search, loading, selectedFile])

  useEffect(() => {
    AppManager.setModalActive(visible)
    return () => {
      AppManager.setModalActive(false)
    }
  }, [visible])

  const closeDrawer = useCallback(() => {
    closeModal()
    setSearch('')
  }, [closeModal, setSearch])

  return (
    <BottomDrawer
      bottomModal={visible}
      closeFeed={closeDrawer}
      website={websiteData}
      authenticated={authenticated}
      disablePlayground
      disableTabs
    />
  )
}
